import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [hp, setHp] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const valid = form.name.length >= 2 && /.+@.+\..+/.test(form.email) && form.subject.length >= 2 && form.message.length >= 5;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/public/contact", { ...form, website: hp });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send your message.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done)
    return (
      <div className="wyv-container py-16">
        <Card className="max-w-xl mx-auto"><CardContent className="p-8 text-center">
          <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="h-6 w-6 text-emerald-700" />
          </div>
          <h1 className="font-heading font-bold text-xl" data-testid="contact-success-title">Message received</h1>
          <p className="text-sm text-muted-foreground mt-3">Thank you. We will reply by email.</p>
        </CardContent></Card>
      </div>
    );

  return (
    <div className="wyv-container py-12 sm:py-16">
      <div className="max-w-2xl">
        <h1 className="font-heading font-bold text-3xl sm:text-4xl text-foreground" data-testid="contact-title">Contact</h1>
        <p className="text-muted-foreground mt-3">Questions about the platform, participation, privacy, or verification.</p>
        <div className="flex flex-wrap gap-4 mt-4 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1.5"><Mail className="h-4 w-4" /> support@witnessyourvote.ca</span>
          <span className="inline-flex items-center gap-1.5"><Mail className="h-4 w-4" /> candidates@witnessyourvote.ca</span>
        </div>
      </div>
      <form onSubmit={submit} className="mt-8 max-w-xl">
        <Card><CardContent className="p-6 sm:p-8 space-y-5">
          <input type="text" value={hp} onChange={(e) => setHp(e.target.value)} className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" name="website" />
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <Label>Name *</Label>
              <Input className="mt-1.5" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="contact-name" />
            </div>
            <div>
              <Label>Email *</Label>
              <Input type="email" className="mt-1.5" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="contact-email" />
            </div>
          </div>
          <div>
            <Label>Subject *</Label>
            <Input className="mt-1.5" value={form.subject} onChange={(e) => set("subject", e.target.value)} data-testid="contact-subject" />
          </div>
          <div>
            <Label>Message *</Label>
            <Textarea className="mt-1.5" rows={5} value={form.message} onChange={(e) => set("message", e.target.value)} data-testid="contact-message" />
          </div>
          <Button type="submit" className="w-full h-11" disabled={!valid || submitting} data-testid="contact-submit-button">
            {submitting ? "Sending…" : "Send message"}
          </Button>
        </CardContent></Card>
      </form>
    </div>
  );
}
